/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityAssetsIpAddressesGeoip
 */
export interface ControlEntityAssetsIpAddressesGeoip {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsIpAddressesGeoip
     */
    city_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsIpAddressesGeoip
     */
    country_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsIpAddressesGeoip
     */
    country_code?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ControlEntityAssetsIpAddressesGeoip
     */
    loc?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityAssetsIpAddressesGeoip
     */
    time_zone?: string;
}

/**
 * Check if a given object implements the ControlEntityAssetsIpAddressesGeoip interface.
 */
export function instanceOfControlEntityAssetsIpAddressesGeoip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityAssetsIpAddressesGeoipFromJSON(json: any): ControlEntityAssetsIpAddressesGeoip {
    return ControlEntityAssetsIpAddressesGeoipFromJSONTyped(json, false);
}

export function ControlEntityAssetsIpAddressesGeoipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetsIpAddressesGeoip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city_name': !exists(json, 'city_name') ? undefined : json['city_name'],
        'country_name': !exists(json, 'country_name') ? undefined : json['country_name'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
        'loc': !exists(json, 'loc') ? undefined : json['loc'],
        'time_zone': !exists(json, 'time_zone') ? undefined : json['time_zone'],
    };
}

export function ControlEntityAssetsIpAddressesGeoipToJSON(value?: ControlEntityAssetsIpAddressesGeoip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city_name': value.city_name,
        'country_name': value.country_name,
        'country_code': value.country_code,
        'loc': value.loc,
        'time_zone': value.time_zone,
    };
}

